export default {"src":"/_next/static/media/WalletAPPDark.3d9900dc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};